import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function containsOne(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let hasOne = false;
    if (!control) {
      return null;
    }
    const group = control as FormGroup;

    if (group.value.includes(true)) {
      hasOne = true;
    }

    return hasOne
      ? null
      : {
          validateContainsOne: { valid: false }
        };
  };
}
